import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const Spinner = styled.span<{ $size?: number }>`
  &&& {
    width: ${({ $size }) => pxToRem(`${$size || 48}`)};
    height: ${({ $size }) => pxToRem(`${$size || 48}`)};
    border-radius: 50%;
    display: inline-block;
    border-top: ${pxToRem(3)} solid ${({ theme }) => theme.colors.brand1};
    border-right: ${pxToRem(3)} solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
